<template>
  <div class="home">
    <Flipbook
      ref="flipbook"
      class="flipbook"
      :pages="pages"
      :singlePage="true"
      :zooms="[1]"
      @flip-left-start="hideUI"
      @flip-left-end="onFlipLeftEnd"
      @flip-right-start="hideUI"
      @flip-right-end="onFlipRightEnd"
    >
    </Flipbook>

    <div v-if="ui && !grabbing" class="pageUI">
      <div v-if="page == 3">
        <b-form-select
          ref="nof1"
          v-model="questions[0][0]"
          style="top: 59.5%; left: 51.05%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: 'Lilly Pilly' },
            { value: 'Pigface', text: 'Pigface' },
            { value: 'Warrigal Greens', text: 'Warrigal Greens' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[0][0]) && end != false"
          style="top: 59.5%; left: 51.05%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[0][0]) && end != false"
          style="top: 59.5%; left: 51.05%"
        />

        <b-form-select
          ref="nof2"
          v-model="questions[0][1]"
          style="top: 65.1%; left: 51.05%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Wombat Berry', text: 'Wombat Berry' },
            { value: 0, text: 'Hop Bush' },
            { value: 'Coast Wattle', text: 'Coast Wattle' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[0][1]) && end != false"
          style="top: 65.1%; left: 51.05%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[0][1]) && end != false"
          style="top: 65.1%; left: 51.05%"
        />
        <!--
        <b-form-select ref="fuf1" v-model="questions[0][2]" style="top: 78.9%; left: 51.05%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Food' },{ value: true, text: 'Medicine' },{ value: true, text: 'Shelter' },{ value: false, text: 'Hunting' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[0][2]==false && end!=false" style="top: 78.9%; left: 51.05%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[0][2]!=false && end!=false" style="top: 78.9%; left: 51.05%">

        <b-form-select ref="fuf2" v-model="questions[0][3]" style="top: 84.5%; left: 51.05%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Trade' },{ value: true, text: 'Tools' },{ value: false, text: 'Weaving' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[0][3]==false && end!=false" style="top: 84.5%; left: 51.05%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[0][3]!=false && end!=false" style="top: 84.5%; left: 51.05%">
        -->

        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="use"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 15.5%; top: 78%" value="food"
            >Food</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((use.includes('food') && !useAnswers.includes('food')) ||
                (useAnswers.includes('food') && !use.includes('food'))) &&
              end != false
            "
            style="left: 15.5%; top: 78%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              use.includes('food') &&
              useAnswers.includes('food') &&
              end != false
            "
            style="left: 15.5%; top: 78%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 84%" value="medicine"
            >Medicine</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((use.includes('medicine') && !useAnswers.includes('medicine')) ||
                (useAnswers.includes('medicine') &&
                  !use.includes('medicine'))) &&
              end != false
            "
            style="left: 15.5%; top: 84%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              use.includes('medicine') &&
              useAnswers.includes('medicine') &&
              end != false
            "
            style="left: 15.5%; top: 84%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 84%" value="shelter"
            >Shelter</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((use.includes('shelter') && !useAnswers.includes('shelter')) ||
                (useAnswers.includes('shelter') && !use.includes('shelter'))) &&
              end != false
            "
            style="left: 69.5%; top: 84%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              use.includes('shelter') &&
              useAnswers.includes('shelter') &&
              end != false
            "
            style="left: 69.5%; top: 84%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 78%" value="hunting"
            >Hunting</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((use.includes('hunting') && !useAnswers.includes('hunting')) ||
                (useAnswers.includes('hunting') && !use.includes('hunting'))) &&
              end != false
            "
            style="left: 42.5%; top: 78%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              use.includes('hunting') &&
              useAnswers.includes('hunting') &&
              end != false
            "
            style="left: 42.5%; top: 78%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 84%" value="trade"
            >Trade</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((use.includes('trade') && !useAnswers.includes('trade')) ||
                (useAnswers.includes('trade') && !use.includes('trade'))) &&
              end != false
            "
            style="left: 42.5%; top: 84%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              use.includes('trade') &&
              useAnswers.includes('trade') &&
              end != false
            "
            style="left: 42.5%; top: 84%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 78%" value="tools"
            >Tools</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((use.includes('tools') && !useAnswers.includes('tools')) ||
                (useAnswers.includes('tools') && !use.includes('tools'))) &&
              end != false
            "
            style="left: 69.5%; top: 78%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              use.includes('tools') &&
              useAnswers.includes('tools') &&
              end != false
            "
            style="left: 69.5%; top: 78%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>

      <div v-if="page == 4">
        <b-form-select
          v-model="questions[1][0]"
          style="top: 56.99%; left: 48.88%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Whale', text: 'Whale' },
            { value: 'Shark', text: 'Shark' },
            { value: 'Fish', text: 'Fish' },
            { value: 'Bird', text: 'Bird' },
            { value: 'Turtle', text: 'Turtle' },
            { value: 'Spirit Figures', text: 'Spirit Figures' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[1][0]) && end != false"
          style="top: 56.99%; left: 48.88%"
        />
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[1][0]) && end != false"
          style="top: 56.99%; left: 48.88%"
        />

        <b-form-select
          v-model="questions[8][0]"
          style="top: 72.1%; left: 47.9%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: 'Overgrown by plants' },
            { value: 'Covered over by a road', text: 'Covered over by a road' },
            { value: 1, text: 'A building was built on it' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[8][0]) && end != false"
          style="top: 72.1%; left: 47.9%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[8][0]) && end != false"
          style="top: 72.1%; left: 47.9%"
        />
      </div>

      <div v-if="page == 5">
        <!--
        <b-form-select v-model="questions[2][0]" style="top: 55.4%; left: 6.4%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Banskia integrifolia' },{ value: false, text: 'Belladonna Lily' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][0]==false && end!=false" style="top: 55.4%; left: 6.4%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][0]!=false && end!=false" style="top: 55.4%; left: 6.4%">

        <b-form-select v-model="questions[2][1]" style="top: 55.4%; left: 50.83%" :options="[{ value: null, text: 'Pick your answer' },{ value: false, text: 'Aloe Vera' },{ value: true, text: 'Lomandra longifolia' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][1]==false && end!=false" style="top: 55.4%; left: 50.83%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][1]!=false && end!=false" style="top: 55.4%; left: 50.83%">

        <b-form-select v-model="questions[2][2]" style="top: 61.2%; left: 6.4%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Westringia fruticosa' },{ value: false, text: 'Barberton Daisy' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][2]==false && end!=false" style="top: 61.2%; left: 6.4%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][2]!=false && end!=false" style="top: 61.2%; left: 6.4%">

        <b-form-select v-model="questions[2][3]" style="top: 61.2%; left: 50.83%" :options="[{ value: null, text: 'Pick your answer' },{ value: false, text: 'Cyclamen Persicum' },{ value: true, text: 'Carpobrotus glauca' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][3]==false && end!=false" style="top: 61.2%; left: 50.83%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][3]!=false && end!=false" style="top: 61.2%; left: 50.83%">
        -->
        <b-form-checkbox-group
          id="checkbox-group-2"
          v-model="plants"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 15.5%; top: 40.55%" value="food"
            >To provide food for native animals</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((plants.includes('food') && !plantAnswers.includes('food')) ||
                (plantAnswers.includes('food') && !plants.includes('food'))) &&
              end != false
            "
            style="left: 15.5%; top: 40.55%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              plants.includes('food') &&
              plantAnswers.includes('food') &&
              end != false
            "
            style="left: 15.5%; top: 40.55%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 46.62%" value="capture"
            >To help capture carbon and produce oxygen</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((plants.includes('capture') &&
                !plantAnswers.includes('capture')) ||
                (plantAnswers.includes('capture') &&
                  !plants.includes('capture'))) &&
              end != false
            "
            style="left: 15.5%; top: 46.62%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              plants.includes('capture') &&
              plantAnswers.includes('capture') &&
              end != false
            "
            style="left: 15.5%; top: 46.62%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 52.69%" value="habitat"
            >To provide habitat (places to live) for native
            animals</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((plants.includes('habitat') &&
                !plantAnswers.includes('habitat')) ||
                (plantAnswers.includes('habitat') &&
                  !plants.includes('habitat'))) &&
              end != false
            "
            style="left: 15.5%; top: 52.69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              plants.includes('habitat') &&
              plantAnswers.includes('habitat') &&
              end != false
            "
            style="left: 15.5%; top: 52.69%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 58.69%" value="biodiversity"
            >To improve biodiversity (more types of living
            things)</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((plants.includes('biodiversity') &&
                !plantAnswers.includes('biodiversity')) ||
                (plantAnswers.includes('biodiversity') &&
                  !plants.includes('biodiversity'))) &&
              end != false
            "
            style="left: 15.5%; top: 58.69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              plants.includes('biodiversity') &&
              plantAnswers.includes('biodiversity') &&
              end != false
            "
            style="left: 15.5%; top: 58.69%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 64.69%" value="corridors"
            >To create wildlife corridors for native animals</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((plants.includes('corridors') &&
                !plantAnswers.includes('corridors')) ||
                (plantAnswers.includes('corridors') &&
                  !plants.includes('corridors'))) &&
              end != false
            "
            style="left: 15.5%; top: 64.69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              plants.includes('corridors') &&
              plantAnswers.includes('corridors') &&
              end != false
            "
            style="left: 15.5%; top: 64.69%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 70.69%" value="environment"
            >To help create a beautiful environment</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((plants.includes('environment') &&
                !plantAnswers.includes('environment')) ||
                (plantAnswers.includes('environment') &&
                  !plants.includes('environment'))) &&
              end != false
            "
            style="left: 15.5%; top: 70.69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              plants.includes('environment') &&
              plantAnswers.includes('environment') &&
              end != false
            "
            style="left: 15.5%; top: 70.69%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>

      <div v-if="page == 6">
        <!--
        <b-form-select v-model="questions[2][0]" style="top: 31.68%; left: 6%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'People' },{ value: false, text: 'Cars and Trucks' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][0]==false && end!=false" style="top: 31.68%; left: 6%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][0]!=false && end!=false" style="top: 31.68%; left: 6%">

        <b-form-select v-model="questions[2][1]" style="top: 31.68%; left: 50.45%" :options="[{ value: null, text: 'Pick your answer' },{ value: false, text: 'Airplanes' },{ value: true, text: 'The Water' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][1]==false && end!=false" style="top: 31.68%; left: 50.45%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][1]!=false && end!=false" style="top: 31.68%; left: 50.45%">

        <b-form-select v-model="questions[2][2]" style="top: 37.52%; left: 6%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Boats' },{ value: false, text: 'Sirens' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][2]==false && end!=false" style="top: 37.52%; left: 6%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][2]!=false && end!=false" style="top: 37.52%; left: 6%">

        <b-form-select v-model="questions[2][3]" style="top: 37.52%; left: 50.45%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Birds' },{ value: false, text: 'Generators' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][3]==false && end!=false" style="top: 37.52%; left: 50.45%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][3]!=false && end!=false" style="top: 37.52%; left: 50.45%">


        <b-form-select v-model="questions[2][4]" style="top: 56.1%; left: 6%" :options="[{ value: null, text: 'Pick your answer' },{ value: false, text: 'Airplanes' },{ value: true, text: 'Birds' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][4]==false && end!=false" style="top: 56.1%; left: 6%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][4]!=false && end!=false" style="top: 56.1%; left: 6%">

        <b-form-select v-model="questions[2][5]" style="top: 56.1%; left: 50.45%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Boats' },{ value: false, text: 'Cars and Trucks' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][5]==false && end!=false" style="top: 56.1%; left: 50.45%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][5]!=false && end!=false" style="top: 56.1%; left: 50.45%">

        <b-form-select v-model="questions[2][6]" style="top: 62%; left: 6%" :options="[{ value: null, text: 'Pick your answer' },{ value: fallse, text: 'Generators' },{ value: true, text: 'The Water' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][6]==false && end!=false" style="top: 62%; left: 6%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][6]!=false && end!=false" style="top: 62%; left: 6%">

        <b-form-select v-model="questions[2][7]" style="top: 62%; left: 50.45%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'People' },{ value: false, text: 'Sirens' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[2][7]==false && end!=false" style="top: 62%; left: 50.45%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[2][7]!=false && end!=false" style="top: 62%; left: 50.45%">
        -->
        <b-form-checkbox-group
          id="checkbox-group-3"
          v-model="hear"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 15.5%; top: 30%" value="people"
            >People</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('people') && !hearAnswers.includes('people') || hearAnswers.includes('people') && !hear.includes('people')) && end!=false" style="left: 15.5%; top: 30%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('people') &&
              hearAnswers.includes('people') &&
              end != false
            "
            style="left: 15.5%; top: 30%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 36%" value="boats"
            >Boats</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('boats') && !hearAnswers.includes('boats') || hearAnswers.includes('boats') && !hear.includes('boats')) && end!=false" style="left: 15.5%; top: 36%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('boats') &&
              hearAnswers.includes('boats') &&
              end != false
            "
            style="left: 15.5%; top: 36%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 42%" value="birds"
            >Birds</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('birds') && !hearAnswers.includes('birds') || hearAnswers.includes('birds') && !hear.includes('birds')) && end!=false" style="left: 15.5%; top: 42%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('birds') &&
              hearAnswers.includes('birds') &&
              end != false
            "
            style="left: 15.5%; top: 42%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 30%" value="animals"
            >Animals</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('animals') && !hearAnswers.includes('animals') || hearAnswers.includes('animals') && !hear.includes('animals')) && end!=false" style="left: 42.5%; top: 30%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('animals') &&
              hearAnswers.includes('animals') &&
              end != false
            "
            style="left: 42.5%; top: 30%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 36%" value="water"
            >The water</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('water') && !hearAnswers.includes('water') || hearAnswers.includes('water') && !hear.includes('water')) && end!=false" style="left: 42.5%; top: 36%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('water') &&
              hearAnswers.includes('water') &&
              end != false
            "
            style="left: 42.5%; top: 36%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 42%" value="sirens"
            >Sirens</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('sirens') && !hearAnswers.includes('sirens') || hearAnswers.includes('sirens') && !hear.includes('sirens')) && end!=false" style="left: 42.5%; top: 42%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('sirens') &&
              hearAnswers.includes('sirens') &&
              end != false
            "
            style="left: 42.5%; top: 42%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 30%" value="airplanes"
            >Airplanes</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('airplanes') && !hearAnswers.includes('airplanes') || hearAnswers.includes('airplanes') && !hear.includes('airplanes')) && end!=false" style="left: 69.5%; top: 30%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('airplanes') &&
              hearAnswers.includes('airplanes') &&
              end != false
            "
            style="left: 69.5%; top: 30%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 36%" value="cars"
            >Cars and Trucks</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('cars') && !hearAnswers.includes('cars') || hearAnswers.includes('cars') && !hear.includes('cars')) && end!=false" style="left: 69.5%; top: 36%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('cars') &&
              hearAnswers.includes('cars') &&
              end != false
            "
            style="left: 69.5%; top: 36%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 42%" value="leaves"
            >Leaves Rustling</b-form-checkbox
          >
          <!-- <img class="indicator" src="/cross.png" v-if="(hear.includes('leaves') && !hearAnswers.includes('leaves') || hearAnswers.includes('leaves') && !hear.includes('leaves')) && end!=false" style="left: 69.5%; top: 42%; transform: translate(-150%, -15%)"> -->
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              hear.includes('leaves') &&
              hearAnswers.includes('leaves') &&
              end != false
            "
            style="left: 69.5%; top: 42%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>

        <b-form-checkbox-group
          id="checkbox-group-4"
          v-model="past"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 15.5%; top: 56%" value="people"
            >People</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('people') && !pastAnswers.includes('people')) ||
                (pastAnswers.includes('people') && !past.includes('people'))) &&
              end != false
            "
            style="left: 15.5%; top: 56%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('people') &&
              pastAnswers.includes('people') &&
              end != false
            "
            style="left: 15.5%; top: 56%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 62%" value="boats"
            >Boats</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('boats') && !pastAnswers.includes('boats')) ||
                (pastAnswers.includes('boats') && !past.includes('boats'))) &&
              end != false
            "
            style="left: 15.5%; top: 62%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('boats') &&
              pastAnswers.includes('boats') &&
              end != false
            "
            style="left: 15.5%; top: 62%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 69%" value="birds"
            >Birds</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('birds') && !pastAnswers.includes('birds')) ||
                (pastAnswers.includes('birds') && !past.includes('birds'))) &&
              end != false
            "
            style="left: 15.5%; top: 69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('birds') &&
              pastAnswers.includes('birds') &&
              end != false
            "
            style="left: 15.5%; top: 69%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 56%" value="animals"
            >Animals</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('animals') && !pastAnswers.includes('animals')) ||
                (pastAnswers.includes('animals') &&
                  !past.includes('animals'))) &&
              end != false
            "
            style="left: 42.5%; top: 56%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('animals') &&
              pastAnswers.includes('animals') &&
              end != false
            "
            style="left: 42.5%; top: 56%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 62%" value="water"
            >The water</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('water') && !pastAnswers.includes('water')) ||
                (pastAnswers.includes('water') && !past.includes('water'))) &&
              end != false
            "
            style="left: 42.5%; top: 62%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('water') &&
              pastAnswers.includes('water') &&
              end != false
            "
            style="left: 42.5%; top: 62%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 42.5%; top: 69%" value="sirens"
            >Sirens</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('sirens') && !pastAnswers.includes('sirens')) ||
                (pastAnswers.includes('sirens') && !past.includes('sirens'))) &&
              end != false
            "
            style="left: 42.5%; top: 69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('sirens') &&
              pastAnswers.includes('sirens') &&
              end != false
            "
            style="left: 42.5%; top: 69%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 56%" value="airplanes"
            >Airplanes</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('airplanes') &&
                !pastAnswers.includes('airplanes')) ||
                (pastAnswers.includes('airplanes') &&
                  !past.includes('airplanes'))) &&
              end != false
            "
            style="left: 69.5%; top: 56%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('airplanes') &&
              pastAnswers.includes('airplanes') &&
              end != false
            "
            style="left: 69.5%; top: 56%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 62%" value="cars"
            >Cars and Trucks</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('cars') && !pastAnswers.includes('cars')) ||
                (pastAnswers.includes('cars') && !past.includes('cars'))) &&
              end != false
            "
            style="left: 69.5%; top: 62%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('cars') &&
              pastAnswers.includes('cars') &&
              end != false
            "
            style="left: 69.5%; top: 62%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 69.5%; top: 69%" value="leaves"
            >Leaves Rustling</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((past.includes('leaves') && !pastAnswers.includes('leaves')) ||
                (pastAnswers.includes('leaves') && !past.includes('leaves'))) &&
              end != false
            "
            style="left: 69.5%; top: 69%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              past.includes('leaves') &&
              pastAnswers.includes('leaves') &&
              end != false
            "
            style="left: 69.5%; top: 69%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>

      <div v-if="page == 7">
        <b-form-select
          v-model="questions[2][0]"
          style="top: 25.63%; left: 50.9%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Old street signs', text: 'Old street signs' },
            { value: 0, text: 'Old coal carts' },
            { value: 1, text: 'Old fuel tanks' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[2][0]) && end != false"
          style="top: 25.63%; left: 50.9%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[2][0]) && end != false"
          style="top: 25.63%; left: 50.9%"
        />

        <b-form-select
          v-model="questions[9][0]"
          style="top: 84.2%; left: 6.3%"
          :options="[
            { value: null, text: 'Pick your answer' },
            {
              value: 'Old jars to hold new things',
              text: 'Old jars to hold new things',
            },
            {
              value: 'Old newspapers for papier mache',
              text: 'Old newspapers for papier mache',
            },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[9][0]) && end != false"
          style="top: 84.2%; left: 6.3%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[9][0]) && end != false"
          style="top: 84.2%; left: 6.3%"
        />

        <b-form-select
          v-model="questions[9][1]"
          style="top: 84.2%; left: 50.9%"
          :options="[
            { value: null, text: 'Pick your answer' },
            {
              value: 'Old boxes to make into a new project',
              text: 'Old boxes to make into a new project',
            },
            {
              value: 'Old toothbrushes as cleaning tools',
              text: 'Old toothbrushes as cleaning tools',
            },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[9][1]) && end != false"
          style="top: 84.2%; left: 50.9%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[9][1]) && end != false"
          style="top: 84.2%; left: 50.9%"
        />

        <b-form-select
          v-model="questions[9][2]"
          style="top: 90%; left: 6.3%"
          :options="[
            { value: null, text: 'Pick your answer' },
            {
              value: 'Buttons or fabric scraps for crafting',
              text: 'Buttons or fabric scraps for crafting',
            },
            {
              value: 'Old plastic bottles as plant pots',
              text: 'Old plastic bottles as plant pots',
            },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[9][2]) && end != false"
          style="top: 90%; left: 6.3%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[9][2]) && end != false"
          style="top: 90%; left: 6.3%"
        />

        <b-form-select
          v-model="questions[9][3]"
          style="top: 90%; left: 50.9%"
          :options="[
            { value: null, text: 'Pick your answer' },
            {
              value: 'Old clothes for cleaning rags',
              text: 'Old clothes for cleaning rags',
            },
            {
              value: 'Old plastic bags to carry shopping',
              text: 'Old plastic bags to carry shopping',
            },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[9][3]) && end != false"
          style="top: 90%; left: 50.9%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[9][3]) && end != false"
          style="top: 90%; left: 50.9%"
        />
        <!--
        <b-form-select v-model="questions[4][1]" style="top: 54.8%; left: 6.3%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Old bricks to make new pathways' },{ value: false, text: 'Old bottles to make new windows' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[4][1]==false && end!=false" style="top: 54.8%; left: 6.3%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[4][1]!=false && end!=false" style="top: 54.8%; left: 6.3%">

        <b-form-select v-model="questions[4][2]" style="top: 54.8%; left: 50.9%" :options="[{ value: null, text: 'Pick your answer' },{ value: false, text: 'Old cans to make new plant pots' },{ value: true, text: 'Old pavers to make new garden beds' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[4][2]==false && end!=false" style="top: 54.8%; left: 50.9%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[4][2]!=false && end!=false" style="top: 54.8%; left: 50.9%">

        <b-form-select v-model="questions[4][3]" style="top: 60.7%; left: 6.3%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Old telegraph poles to make wooden decks' },{ value: false, text: 'Old plastic bags to make rain shelters' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[4][3]==false && end!=false" style="top: 60.7%; left: 6.3%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[4][3]!=false && end!=false" style="top: 60.7%; left: 6.3%">

        <b-form-select v-model="questions[4][4]" style="top: 60.7%; left: 50.9%" :options="[{ value: null, text: 'Pick your answer' },{ value: false, text: 'Old shipping containers to make water tanks' },{ value: true, text: 'Old stones (used as balast in ships) used in the old concrete walls' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[4][4]==false && end!=false" style="top: 60.7%; left: 50.9%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[4][4]!=false && end!=false" style="top: 60.7%; left: 50.9%">


        
        -->
        <b-form-checkbox-group
          id="checkbox-group-5"
          v-model="repurposed"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 18%; top: 45.7%" value="bricks"
            >Old bricks to make new pathways</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((repurposed.includes('bricks') &&
                !repurposeAnswers.includes('bricks')) ||
                (repurposeAnswers.includes('bricks') &&
                  !repurposed.includes('bricks'))) &&
              end != false
            "
            style="left: 18%; top: 45.7%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              repurposed.includes('bricks') &&
              repurposeAnswers.includes('bricks') &&
              end != false
            "
            style="left: 18%; top: 45.7%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 18%; top: 51.7%" value="pavers"
            >Old pavers to make new garden beds</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((repurposed.includes('pavers') &&
                !repurposeAnswers.includes('pavers')) ||
                (repurposeAnswers.includes('pavers') &&
                  !repurposed.includes('pavers'))) &&
              end != false
            "
            style="left: 18%; top: 51.7%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              repurposed.includes('pavers') &&
              repurposeAnswers.includes('pavers') &&
              end != false
            "
            style="left: 18%; top: 51.7%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 18%; top: 57.7%" value="poles"
            >Old telegraph poles to make wooden decks</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((repurposed.includes('poles') &&
                !repurposeAnswers.includes('poles')) ||
                (repurposeAnswers.includes('poles') &&
                  !repurposed.includes('poles'))) &&
              end != false
            "
            style="left: 18%; top: 57.7%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              repurposed.includes('poles') &&
              repurposeAnswers.includes('poles') &&
              end != false
            "
            style="left: 18%; top: 57.7%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 18%; top: 63.7%" value="stones"
            >Old stones (used as balast in ships) used in the old concrete
            walls</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((repurposed.includes('stones') &&
                !repurposeAnswers.includes('stones')) ||
                (repurposeAnswers.includes('stones') &&
                  !repurposed.includes('stones'))) &&
              end != false
            "
            style="left: 18%; top: 63.7%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              repurposed.includes('stones') &&
              repurposeAnswers.includes('stones') &&
              end != false
            "
            style="left: 18%; top: 63.7%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>

      <div v-if="page == 8">
        <b-form-select
          v-model="questions[3][0]"
          style="top: 68.05%; left: 52.45%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: '1' },
            { value: 1, text: '3' },
            { value: '6a', text: '6' },
            { value: 2, text: '10' },
            { value: 3, text: '20' },
            { value: 4, text: '99' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[3][0]) && end != false"
          style="top: 68.05%; left: 52.45%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[3][0]) && end != false"
          style="top: 68.05%; left: 52.45%"
        />
      </div>

      <div v-if="page == 9">
        <b-form-select
          v-model="questions[4][0]"
          style="top: 50.32%; left: 59.55%; width: 33.5%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: '7' },
            { value: 1, text: '15' },
            { value: '16a', text: '16' },
            { value: 2, text: '34' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[4][0]) && end != false"
          style="top: 50.32%; left: 49.55%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[4][0]) && end != false"
          style="top: 50.32%; left: 49.55%"
        />
      </div>

      <div v-if="page == 10">
        <b-form-select
          v-model="questions[5][0]"
          style="top: 16.35%; left: 42%; width: 41.7%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: 'Solar panels' },
            { value: 'Water tanks', text: 'Water tanks' },
            { value: 1, text: 'Coal carts' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[5][0]) && end != false"
          style="top: 16.35%; left: 41%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[5][0]) && end != false"
          style="top: 16.35%; left: 41%"
        />

        <b-form-select
          v-model="questions[10][0]"
          style="top: 31.1%; left: 10.4%; width: 73.3%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: 'Storing food' },
            { value: 1, text: 'Storing coal' },
            { value: 'Storing rain water', text: 'Storing rain water' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[10][0]) && end != false"
          style="top: 31.1%; left: 41%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[10][0]) && end != false"
          style="top: 31.1%; left: 41%"
        />

        <b-form-checkbox-group
          id="checkbox-group-6"
          v-model="bats"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 15.5%; top: 80.05%" value="dark"
            >It is nice and dark</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((bats.includes('dark') && !batsAnswers.includes('dark')) ||
                (batsAnswers.includes('dark') && !bats.includes('dark'))) &&
              end != false
            "
            style="left: 15.5%; top: 80.05%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              bats.includes('dark') &&
              batsAnswers.includes('dark') &&
              end != false
            "
            style="left: 15.5%; top: 80.05%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 86.12%" value="food"
            >There is food nearby</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((bats.includes('food') && !batsAnswers.includes('food')) ||
                (batsAnswers.includes('food') && !bats.includes('food'))) &&
              end != false
            "
            style="left: 15.5%; top: 86.12%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              bats.includes('food') &&
              batsAnswers.includes('food') &&
              end != false
            "
            style="left: 15.5%; top: 86.12%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.5%; top: 92.19%" value="wifi"
            >Great Wifi for our<br />mobiles</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((bats.includes('wifi') && !batsAnswers.includes('wifi')) ||
                (batsAnswers.includes('wifi') && !bats.includes('wifi'))) &&
              end != false
            "
            style="left: 15.5%; top: 92.19%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              bats.includes('wifi') &&
              batsAnswers.includes('wifi') &&
              end != false
            "
            style="left: 15.5%; top: 92.19%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 61.4%; top: 80.05%" value="quiet"
            >It is quiet and sheltered</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((bats.includes('quiet') && !batsAnswers.includes('quiet')) ||
                (batsAnswers.includes('quiet') && !bats.includes('quiet'))) &&
              end != false
            "
            style="left: 61.4%; top: 80.05%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              bats.includes('quiet') &&
              batsAnswers.includes('quiet') &&
              end != false
            "
            style="left: 61.4%; top: 80.05%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 61.4%; top: 86.12%" value="safe"
            >Safe from humans and Predators</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((bats.includes('safe') && !batsAnswers.includes('safe')) ||
                (batsAnswers.includes('safe') && !bats.includes('safe'))) &&
              end != false
            "
            style="left: 61.4%; top: 86.12%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              bats.includes('safe') &&
              batsAnswers.includes('safe') &&
              end != false
            "
            style="left: 61.4%; top: 86.12%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 61.4%; top: 92.19%" value="chooks"
            >It’s close to the<br />chooks</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((bats.includes('chooks') && !batsAnswers.includes('chooks')) ||
                (batsAnswers.includes('chooks') && !bats.includes('chooks'))) &&
              end != false
            "
            style="left: 61.4%; top: 92.19%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              bats.includes('chooks') &&
              batsAnswers.includes('chooks') &&
              end != false
            "
            style="left: 61.4%; top: 92.19%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>

      <div v-if="page == 11">
        <b-form-checkbox-group
          id="checkbox-group-7"
          v-model="people"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 19.5%; top: 46.05%" value="exercise"
            >Exercising</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((people.includes('exercise') &&
                !peopleAnswers.includes('exercise')) ||
                (peopleAnswers.includes('exercise') &&
                  !people.includes('exercise'))) &&
              end != false
            "
            style="left: 19.5%; top: 46.05%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              people.includes('exercise') &&
              peopleAnswers.includes('exercise') &&
              end != false
            "
            style="left: 19.5%; top: 46.05%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 19.5%; top: 52.12%" value="picnic"
            >Having picnics</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((people.includes('picnic') &&
                !peopleAnswers.includes('picnic')) ||
                (peopleAnswers.includes('picnic') &&
                  !people.includes('picnic'))) &&
              end != false
            "
            style="left: 19.5%; top: 52.12%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              people.includes('picnic') &&
              peopleAnswers.includes('picnic') &&
              end != false
            "
            style="left: 19.5%; top: 52.12%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 19.5%; top: 58.19%" value="events"
            >Fun events</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((people.includes('events') &&
                !peopleAnswers.includes('events')) ||
                (peopleAnswers.includes('events') &&
                  !people.includes('events'))) &&
              end != false
            "
            style="left: 19.5%; top: 58.19%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              people.includes('events') &&
              peopleAnswers.includes('events') &&
              end != false
            "
            style="left: 19.5%; top: 58.19%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 61.4%; top: 46.05%" value="scooting"
            >Scooting</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((people.includes('scooting') &&
                !peopleAnswers.includes('scooting')) ||
                (peopleAnswers.includes('scooting') &&
                  !people.includes('scooting'))) &&
              end != false
            "
            style="left: 61.4%; top: 46.05%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              people.includes('scooting') &&
              peopleAnswers.includes('scooting') &&
              end != false
            "
            style="left: 61.4%; top: 46.05%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 61.4%; top: 52.12%" value="friends"
            >Meeting friends</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((people.includes('friends') &&
                !peopleAnswers.includes('friends')) ||
                (peopleAnswers.includes('friends') &&
                  !people.includes('friends'))) &&
              end != false
            "
            style="left: 61.4%; top: 52.12%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              people.includes('friends') &&
              peopleAnswers.includes('friends') &&
              end != false
            "
            style="left: 61.4%; top: 52.12%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 61.4%; top: 58.19%" value="food"
            >Growing food</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((people.includes('food') && !peopleAnswers.includes('food')) ||
                (peopleAnswers.includes('food') && !people.includes('food'))) &&
              end != false
            "
            style="left: 61.4%; top: 58.19%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              people.includes('food') &&
              peopleAnswers.includes('food') &&
              end != false
            "
            style="left: 61.4%; top: 58.19%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>

        <!--
        <b-form-select v-model="questions[8][0]" style="top: 57.7%; left: 6.35%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Exercising' },{ value: true, text: 'Meeting friends' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[8][0]==false && end!=false" style="top: 57.7%; left: 6.35%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[8][0]!=false && end!=false" style="top: 57.7%; left: 6.35%">

        <b-form-select v-model="questions[8][1]" style="top: 57.7%; left: 50.85%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Having picnics' },{ value: true, text: 'Relaxing' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[8][1]==false && end!=false" style="top: 57.7%; left: 50.85%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[8][1]!=false && end!=false" style="top: 57.7%; left: 50.85%">

        <b-form-select v-model="questions[8][2]" style="top: 63.6%; left: 6.35%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Fun events' },{ value: true, text: 'Chatting' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[8][2]==false && end!=false" style="top: 63.6%; left: 6.35%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[8][2]!=false && end!=false" style="top: 63.6%; left: 6.35%">

        <b-form-select v-model="questions[8][3]" style="top: 63.6%; left: 50.85%" :options="[{ value: null, text: 'Pick your answer' },{ value: true, text: 'Scooting' },{ value: true, text: 'Learning' }]"></b-form-select>
        <img class="indicator" src="/cross.png" v-if="!isNaN(questions[8][3]==false && end!=false" style="top: 63.6%; left: 50.85%">
        <img class="indicator" src="/tick.png" v-if="isNaN(questions[8][3]!=false && end!=false" style="top: 63.6%; left: 50.85%">
        -->

        <b-form-select
          v-model="questions[6][0]"
          style="top: 83.6%; left: 6.35%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Solar power', text: 'Solar power' },
            { value: 'Growing food', text: 'Growing food' },
            { value: 0, text: 'Coal power' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[6][0]) && end != false"
          style="top: 83.6%; left: 6.35%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[6][0]) && end != false"
          style="top: 83.6%; left: 6.35%"
        />

        <b-form-select
          v-model="questions[6][1]"
          style="top: 83.6%; left: 50.85%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Native gardens', text: 'Native gardens' },
            { value: 0, text: 'Steam engines' },
            { value: 'Rainwater harvesting', text: 'Rainwater harvesting' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[6][1]) && end != false"
          style="top: 83.6%; left: 50.85%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[6][1]) && end != false"
          style="top: 83.6%; left: 50.85%"
        />
      </div>

      <div v-if="page == 12">
        <b-form-select
          v-model="questions[7][0]"
          style="top: 34%; left: 6.35%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Princess Layer', text: 'Princess Layer' },
            { value: 'Coco', text: 'Coco' },
            { value: 'Peach', text: 'Peach' },
            { value: 'Yolko Ono', text: 'Yolko Ono' },
            { value: 'Magpie', text: 'Magpie' },
            { value: false, text: 'Cluck Kent' },
            { value: 'Cluck Norris', text: 'Cluck Norris' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[7][0]) && end != false"
          style="top: 34%; left: 6.35%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[7][0]) && end != false"
          style="top: 34%; left: 6.35%"
        />

        <b-form-select
          v-model="questions[7][1]"
          style="top: 34%; left: 50.85%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 'Blue', text: 'Blue' },
            { value: 'Rosie', text: 'Rosie' },
            { value: 'Henneth Paltrow', text: 'Henneth Paltrow' },
            { value: 'Immogen', text: 'Immogen' },
            { value: 'Hen Solo', text: 'Hen Solo' },
            { value: false, text: 'Chicksilver' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[7][1]) && end != false"
          style="top: 34%; left: 50.85%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[7][1]) && end != false"
          style="top: 34%; left: 50.85%"
        />

        <b-form-select
          v-model="questions[11][0]"
          style="top: 51.5%; left: 6.35%"
          :options="[
            { value: null, text: 'Pick your answer' },
            { value: 0, text: 'Their great conversation skills' },
            {
              value: 'They produce eggs which the volunteers can eat',
              text: 'They produce eggs which the volunteers can eat',
            },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[11][0]) && end != false"
          style="top: 51.5%; left: 6.35%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[11][0]) && end != false"
          style="top: 51.5%; left: 6.35%"
        />

        <b-form-select
          v-model="questions[11][1]"
          style="top: 51.5%; left: 50.85%"
          :options="[
            { value: null, text: 'Pick your answer' },
            {
              value: 'They eat the food scraps from the gardens',
              text: 'They eat the food scraps from the gardens',
            },
            { value: 0, text: 'They are super-cute!' },
          ]"
        ></b-form-select>
        <img
          class="indicator"
          src="/cross.png"
          v-if="!isNaN(questions[11][1]) && end != false"
          style="top: 51.5%; left: 50.85%"
        />
        <img
          class="indicator"
          src="/tick.png"
          v-if="isNaN(questions[11][1]) && end != false"
          style="top: 51.5%; left: 50.85%"
        />
      </div>

      <div v-if="page == 13">
        <b-form-checkbox-group
          id="checkbox-group-8"
          v-model="garden"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 16.3%; top: 49.46%" value="compost"
            >Compost</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('compost') &&
                !gardenAnswers.includes('compost')) ||
                (gardenAnswers.includes('compost') &&
                  !garden.includes('compost'))) &&
              end != false
            "
            style="left: 16.3%; top: 49.46%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('compost') &&
              gardenAnswers.includes('compost') &&
              end != false
            "
            style="left: 16.3%; top: 49.46%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 16.3%; top: 55.52%" value="beehive"
            >Native Beehive</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('beehive') &&
                !gardenAnswers.includes('beehive')) ||
                (gardenAnswers.includes('beehive') &&
                  !garden.includes('beehive'))) &&
              end != false
            "
            style="left: 16.3%; top: 55.52%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('beehive') &&
              gardenAnswers.includes('beehive') &&
              end != false
            "
            style="left: 16.3%; top: 55.52%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 16.3%; top: 61.58%" value="veg"
            >Vegetables</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('veg') && !gardenAnswers.includes('veg')) ||
                (gardenAnswers.includes('veg') && !garden.includes('veg'))) &&
              end != false
            "
            style="left: 16.3%; top: 61.58%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('veg') &&
              gardenAnswers.includes('veg') &&
              end != false
            "
            style="left: 16.3%; top: 61.58%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 16.3%; top: 67.64%" value="beds"
            >Multi-level garden beds</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('beds') && !gardenAnswers.includes('beds')) ||
                (gardenAnswers.includes('beds') && !garden.includes('beds'))) &&
              end != false
            "
            style="left: 16.3%; top: 67.64%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('beds') &&
              gardenAnswers.includes('beds') &&
              end != false
            "
            style="left: 16.3%; top: 67.64%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 62.1%; top: 49.46%" value="worms"
            >Worm Farms</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('worms') && !gardenAnswers.includes('worms')) ||
                (gardenAnswers.includes('worms') &&
                  !garden.includes('worms'))) &&
              end != false
            "
            style="left: 62.1%; top: 49.46%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('worms') &&
              gardenAnswers.includes('worms') &&
              end != false
            "
            style="left: 62.1%; top: 49.46%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 62.1%; top: 55.52%" value="fruits"
            >Fruits</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('fruits') &&
                !gardenAnswers.includes('fruits')) ||
                (gardenAnswers.includes('fruits') &&
                  !garden.includes('fruits'))) &&
              end != false
            "
            style="left: 62.1%; top: 55.52%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('fruits') &&
              gardenAnswers.includes('fruits') &&
              end != false
            "
            style="left: 62.1%; top: 55.52%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 62.1%; top: 61.58%" value="greens"
            >Edible leafy greens</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('greens') &&
                !gardenAnswers.includes('greens')) ||
                (gardenAnswers.includes('greens') &&
                  !garden.includes('greens'))) &&
              end != false
            "
            style="left: 62.1%; top: 61.58%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('greens') &&
              gardenAnswers.includes('greens') &&
              end != false
            "
            style="left: 62.1%; top: 61.58%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 62.1%; top: 67.64%" value="flowers"
            >Flowers to attract bugs and pollinators</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((garden.includes('flowers') &&
                !gardenAnswers.includes('flowers')) ||
                (gardenAnswers.includes('flowers') &&
                  !garden.includes('flowers'))) &&
              end != false
            "
            style="left: 62.1%; top: 67.64%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              garden.includes('flowers') &&
              gardenAnswers.includes('flowers') &&
              end != false
            "
            style="left: 62.1%; top: 67.64%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>

      <div v-if="page == 14">
        <b-form-checkbox-group
          id="checkbox-group-9"
          v-model="environment"
          name="flavour-2"
        >
          <b-form-checkbox style="left: 15.03%; top: 70%" value="solar"
            >Rooftop solar panels<br />to make energy</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((environment.includes('solar') &&
                !environmentAnswers.includes('solar')) ||
                (environmentAnswers.includes('solar') &&
                  !environment.includes('solar'))) &&
              end != false
            "
            style="left: 15.03%; top: 70%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              environment.includes('solar') &&
              environmentAnswers.includes('solar') &&
              end != false
            "
            style="left: 15.03%; top: 70%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.03%; top: 79%" value="conditioners"
            >Reverse cycle air<br />conditioners</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((environment.includes('conditioners') &&
                !environmentAnswers.includes('conditioners')) ||
                (environmentAnswers.includes('conditioners') &&
                  !environment.includes('conditioners'))) &&
              end != false
            "
            style="left: 15.03%; top: 79%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              environment.includes('conditioners') &&
              environmentAnswers.includes('conditioners') &&
              end != false
            "
            style="left: 15.03%; top: 79%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 15.05%; top: 88%" value="pergola"
            >Pergola for sun<br />shading</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((environment.includes('pergola') &&
                !environmentAnswers.includes('pergola')) ||
                (environmentAnswers.includes('pergola') &&
                  !environment.includes('pergola'))) &&
              end != false
            "
            style="left: 15.05%; top: 88%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              environment.includes('pergola') &&
              environmentAnswers.includes('pergola') &&
              end != false
            "
            style="left: 15.05%; top: 88%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 60.9%; top: 70%" value="curtains"
            >Curtains to keep the warmth in during winter</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((environment.includes('curtains') &&
                !environmentAnswers.includes('curtains')) ||
                (environmentAnswers.includes('curtains') &&
                  !environment.includes('curtains'))) &&
              end != false
            "
            style="left: 60.9%; top: 70%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              environment.includes('curtains') &&
              environmentAnswers.includes('curtains') &&
              end != false
            "
            style="left: 60.9%; top: 70%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 60.9%; top: 79%" value="glazing"
            >Window double glazing</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((environment.includes('glazing') &&
                !environmentAnswers.includes('glazing')) ||
                (environmentAnswers.includes('glazing') &&
                  !environment.includes('glazing'))) &&
              end != false
            "
            style="left: 60.9%; top: 79%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              environment.includes('glazing') &&
              environmentAnswers.includes('glazing') &&
              end != false
            "
            style="left: 60.9%; top: 79%; transform: translate(-150%, -15%)"
          />

          <b-form-checkbox style="left: 60.9%; top: 88%" value="fans"
            >Ceiling fans</b-form-checkbox
          >
          <img
            class="indicator"
            src="/cross.png"
            v-if="
              ((environment.includes('fans') &&
                !environmentAnswers.includes('fans')) ||
                (environmentAnswers.includes('fans') &&
                  !environment.includes('fans'))) &&
              end != false
            "
            style="left: 60.9%; top: 88%; transform: translate(-150%, -15%)"
          />
          <img
            class="indicator"
            src="/tick.png"
            v-if="
              environment.includes('fans') &&
              environmentAnswers.includes('fans') &&
              end != false
            "
            style="left: 60.9%; top: 88%; transform: translate(-150%, -15%)"
          />
        </b-form-checkbox-group>
      </div>
    </div>

    <b-modal
      id="modal-1"
      title="Trail Complete!"
      ok-only
      header-bg-variant="info"
      header-text-variant="light"
      header-close-variant="light"
      body-bg-variant="light"
      body-text-variant="info"
      footer-bg-variant="info"
      ok-variant="light"
      hide-footer
    >
      <h1>Well done!</h1>
      <h3 class="my-2">
        <br />You've completed the<br /><b>Sustainability Trail</b
        >.<br /><br />You answered {{ score }} questions correctly out of
        {{ max }}.<br /><br />
      </h3>
      <h4>
        <span v-if="score < max"
          >Flip back through the pages to check your answers.</span
        ><span v-if="score == max">Perfect! Great work.</span>
      </h4>
      <hr />
      <b-link
        href="http://www.northsydney.nsw.gov.au/CoalLoader"
        style="color: #17a2b8"
        ><h3><i>Check out The Coal Loader</i></h3></b-link
      >
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import qs from "querystring";
// @ is an alias to /src
import Flipbook from "flipbook-vue";
export default {
  name: "Home",
  components: { Flipbook },
  data: function () {
    return {
      end: false,
      use: [],
      useAnswers: ["food"],
      hear: [],
      hearAnswers: [
        "people",
        "boats",
        "birds",
        "animals",
        "water",
        "leaves",
        "sirens",
        "airplanes",
        "cars",
      ],
      past: [],
      pastAnswers: ["people", "birds", "animals", "water", "leaves"],
      plants: [],
      plantAnswers: [
        "food",
        "capture",
        "habitat",
        "biodiversity",
        "corridors",
        "environment",
      ],
      repurposed: [],
      repurposeAnswers: ["bricks", "pavers", "poles", "stones"],
      people: [],
      peopleAnswers: [
        "exercise",
        "picnic",
        "events",
        "scooting",
        "friends",
        "food",
      ],
      bats: [],
      batsAnswers: ["dark", "food", "quiet", "safe"],
      garden: [],
      gardenAnswers: [
        "compost",
        "beehive",
        "veg",
        "beds",
        "worms",
        "fruits",
        "greens",
        "flowers",
      ],
      environment: [],
      environmentAnswers: [
        "solar",
        "conditioners",
        "pergola",
        "curtains",
        "glazing",
        "fans",
      ],
      questions: [
        [null, null], //Question 1                1-1 bush foods 1
        [null], //Question 2                      2-1 rock 1
        [null], //Question 4                      5-1 serpent 1
        [null], //Question 6                      6 tunnel 1    NOT WORKING
        [null], //Question 7                      7 tunnel 2
        [null], //Question 8                      8-1 tunnel 3 1
        [null, null], // Question 10              9-2 platform 2
        [null, null], // Question 11              10-1 chickens 1
        [null], //Question 3                      2-2 rock 2
        [null, null, null, null], //Question 5    5-3 serpent 3
        [null], //Question 9                      8-2 tunnel 3 2
        [null, null], //Question 12               10-2 chickens 2
      ],
      // use*
      // plants*
      // hear*
      // past*
      // people*
      // garden*
      // environment*
      pages: [
        null,
        "0_corner.png",
        "1_corner.png",
        "2_corner.png",
        "3_corner.png",
        "Artboard – 4.png",
        "5_corner.png",
        "Artboard – 6.png",
        "7_corner.png",
        "8_corner.png",
        "9_corner.png",
        "10_corner.png",
        "11_corner.png",
        "12_corner.png",
        "13_corner.png",
        "14.png",
      ],
      ui: true,
      grabbing: false,
      page: 0,
      flipbook: null,
      score: 0,
      max: 0,
    };
  },
  methods: {
    async view() {
      try {
        await axios.post("/view");
        //await axios.post(qs.stringify());
      } catch (error) {
        //console.log("error viewing");
      }
    },
    async submitScore(score_array) {
      try {
        //console.log(score_array);
        await axios.post(
          "/score",
          qs.stringify({
            score: score_array,
          })
        );
      } catch (error) {
        //console.log("error scoring");
      }
    },
    areArraysEqualSets(a1, a2) {
      let superSet = {};
      for (let i = 0; i < a1.length; i++) {
        const e = a1[i] + typeof a1[i];
        superSet[e] = 1;
      }

      for (let i = 0; i < a2.length; i++) {
        const e = a2[i] + typeof a2[i];
        if (!superSet[e]) {
          return false;
        }
        superSet[e] = 2;
      }

      for (let e in superSet) {
        if (superSet[e] === 1) {
          return false;
        }
      }

      return true;
    },
    areThereNoWrongAnswers(a1, a2) {
      for (let answer of a1) {
        if (!a2.includes(answer)) {
          return false;
        }
      }
      return true;
    },
    getScore() {
      let total = 0;
      let max = 0;
      let score_array = [
        false, // 1-1   *         0<----  (1-1) CORRECT
        false, // 1   *           1       1-2   CORRECT
        false, // 2-1   *         2<----  (2-1) CORRECT
        false, // 5-1   *         3<----  (5-1) CORRECT
        false, // 3   *           4       3     CORRECT
        true, // 4   *           5       4-1   CORRECT X
        false, // 4   *           6       4-2   CORRECT
        false, // 7   *           7<----  (6)     <<<?! feeding into i5
        false, // 5   *           8       5-2   CORRECT
        false, // 8-1             9<----  (7)     <<<?! feeding into i7
        false, // 9   *           10<---- (8-1)   <<<?! feeding into i9
        false, // 10  *           11<---- (9-2)   <<<?! feeding into i10
        false, // 2   *           12<---- (10-1)  <<<?! feeding into i11
        false, // 5   *           13<---- (2-2)   <<<?! feeding into i12
        false, // 8-3             14      8-3   CORRECT
        false, // 9   *           15      9-1   CORRECT X
        false, // 10  *           16<---- (5-3)   <<<?! feeding into i13
        false, //                 17<---- (8-2)   <<<?! feeding into i15
        false, //                 18<---- (10-2)  <<<?! feeding into i16
        false, // 11              19      11    CORRECT
        false, // 12              20      12    CORRECT
      ];
      // 6 IS MISSING (what number is painted on it?)
      // 8 2 IS MISSING (reasons why)
      let current_question = 0;
      //console.log(this.questions);
      for (let question of this.questions) {
        let loop = true;
        while (loop) {
          loop = false;
          if (
            current_question == 1 ||
            current_question == 4 ||
            current_question == 5 ||
            current_question == 6 ||
            current_question == 8 ||
            current_question == 14 ||
            current_question == 15
          ) {
            loop = true;
            ++current_question;
          }
        }

        //console.log(current_question);

        ++max;
        let correct = true;
        for (let answer of question) {
          if (!isNaN(answer)) {
            correct = false;
          }
        }
        if (correct) ++total;
        score_array[current_question] = correct;
        //console.log(current_question);
        ++current_question;
      }

      ++max;
      if (this.areArraysEqualSets(this.use, this.useAnswers)) {
        ++total;
        score_array[1] = true;
      } else {
        score_array[1] = false;
      }

      ++max;
      if (this.areThereNoWrongAnswers(this.hear, this.hearAnswers)) {
        ++total;
        score_array[5] = true;
      } else {
        score_array[5] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.past, this.pastAnswers)) {
        ++total;
        score_array[6] = true;
      } else {
        score_array[6] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.bats, this.batsAnswers)) {
        ++total;
        score_array[14] = true;
      } else {
        score_array[14] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.plants, this.plantAnswers)) {
        ++total;
        score_array[4] = true;
      } else {
        score_array[4] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.repurposed, this.repurposeAnswers)) {
        ++total;
        score_array[8] = true;
      } else {
        score_array[8] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.people, this.peopleAnswers)) {
        ++total;
        score_array[15] = true;
      } else {
        score_array[15] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.garden, this.gardenAnswers)) {
        ++total;
        score_array[19] = true;
      } else {
        score_array[19] = false;
      }

      ++max;
      if (this.areArraysEqualSets(this.environment, this.environmentAnswers)) {
        ++total;
        score_array[20] = true;
      } else {
        score_array[20] = false;
      }

      this.score = total;
      this.max = max;
      //if (!this.end) {
      this.submitScore(score_array);
      //}
      this.end = true;
    },
    onFlipLeftEnd(page) {
      this.page = page;
      this.ui = true;
    },
    hideUI() {
      this.ui = false;
    },
    onFlipRightEnd(page) {
      this.page = page;
      if (this.page == 15) {
        this.getScore();
        this.$bvModal.show("modal-1");
      }
      this.ui = true;
    },
    checkGrab() {
      this.grabbing = this.flipbook.cursor == "grabbing";
    },
  },
  mounted() {
    window.addEventListener("mousemove", this.checkGrab);
    window.addEventListener("touchend", this.checkGrab);
    window.addEventListener("touchmove", this.checkGrab);
    this.flipbook = this.$refs["flipbook"];
    this.view();
  },
};
</script>

<style>
.custom-control-label {
  user-select: none;
  text-align: left;
}
.custom-control-label::before {
  pointer-events: auto;
  border-radius: 0 !important;
}
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ffa800;
  border-color: #ffa800;
}
@media (min-aspect-ratio: 1000/1334) {
  .custom-control-label {
    font-size: 2.07vh;
    line-height: 2.07vh;
  }
  .custom-control-label::before {
    width: 5vh;
    height: 5vh;
    left: -7vh;
    top: -0.6vh;
    border: 0.5vh solid #ffa800;
  }
  .custom-control-label::after {
    display: none;
  }
}
@media (max-aspect-ratio: 1000/1334) {
  .custom-control-label {
    font-size: 2.76138vw;
    line-height: 2.76138vw;
  }
  .custom-control-label::before {
    width: 6.67vw;
    height: 6.67vw;
    left: -9.338vw;
    top: -0.8004vw;
    border: 0.667vw solid #ffa800;
  }
  .custom-control-label::after {
    display: none;
  }
}

.bounding-box {
  box-shadow: 0 0 5vmin !important;
}
</style>

<style>
.flipbook {
  background-image: radial-gradient(#feffff, #a0d1cf);
}
@media (min-aspect-ratio: 1000/1334) {
  .pageUI {
    width: 74.963396778vh !important;
    height: 100vh;
  }
  .custom-select,
  .custom-checkbox {
    font-size: 2.3vh;
  }
}
@media (max-aspect-ratio: 1000/1334) {
  .pageUI {
    width: 100vw;
    height: 133.3984375vw;
  }
  .custom-select,
  .custom-checkbox {
    font-size: 3.0681640625vw;
  }
}
.flipbook {
  position: absolute;
  width: auto;
  height: 100%;
  margin: auto;
  left: 0;
  right: 0;
}
.pageUI {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  pointer-events: none;
}
.custom-select,
.custom-checkbox {
  pointer-events: auto;
  font-family: Atlantic;
  top: 0;
  position: absolute;
  animation: fadeIn 0.5s forwards;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
}

.custom-checkbox {
  font-weight: bold;
}

.custom-select {
  width: 39%;
  height: 4.65%;
  padding-left: 1.5%;
  background: none;
  font-family: Atlantic;
  text-overflow: ellipsis;
}

.indicator {
  position: absolute;
  width: 10%;
  height: 5%;
  transform: translateX(370%);
  animation: fadeInHighlight 0.5s forwards;
  margin: 0;
  padding: 0;
}

input[type="checkbox"] {
  display: none !important;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeInHighlight {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.7;
  }
}
</style>
